import React from "react";
import { defineMessages, useIntl } from "react-intl";
import "../../../components/circle-box/CircleBoxWithText.js";
import { CircleBoxWithColorMapping } from "../../../components/circle-box/CircleBoxWithColorMapping.js";
import "../../../components/circle-box/CircleBox.js";
import { SystemColorsEnum } from "../../../style/types.js";
import "@mui/material";
import "../../../style/hooks.js";
const localizedPlatform = defineMessages({
  NONE: {
    id: "platformNone",
    defaultMessage: "None"
  },
  UNKNOWN: {
    id: "platformUnknown",
    defaultMessage: "Unknown"
  },
  PKW: {
    id: "platformPkw",
    defaultMessage: "PKW"
  },
  WPK: {
    id: "platformWPK",
    defaultMessage: "WPK"
  },
  WPTO: {
    id: "platformWPTO",
    defaultMessage: "WPTG"
  },
  NJ: {
    id: "platformNj",
    defaultMessage: "NJ"
  },
  IM: {
    id: "platformIm",
    defaultMessage: "IM"
  },
  MT: {
    id: "platformMt",
    defaultMessage: "MT"
  },
  BL: {
    id: "platformBl",
    defaultMessage: "BL"
  },
  MEME: {
    id: "platformMeme",
    defaultMessage: "MEME"
  },
  WPTG: {
    id: "platformWPTG",
    defaultMessage: "WPTG"
  },
  WPTGO: {
    id: "platformWPTGO",
    defaultMessage: "WPTGO"
  },
  WPTGPUKE: {
    id: "platformWPTGPUKE",
    defaultMessage: "WPTG Puke"
  },
  NEXAPOKER: {
    id: "platformNEXAPOKER",
    defaultMessage: "Nexa Poker"
  },
  AKSPOKER: {
    id: "platformAKSPOKER",
    defaultMessage: "AKs Poker"
  }
});
function UserPlatform({ value }) {
  const { formatMessage } = useIntl();
  const colorMapping = {
    BL: SystemColorsEnum.SkyBlue,
    IM: SystemColorsEnum.DarkTeal,
    MEME: SystemColorsEnum.Violet,
    MT: SystemColorsEnum.Orange,
    NJ: SystemColorsEnum.Red,
    NONE: SystemColorsEnum.DarkGrey,
    PKW: SystemColorsEnum.DarkPink,
    WPK: SystemColorsEnum.Emerald,
    WPTO: SystemColorsEnum.LightBlue,
    WPTG: SystemColorsEnum.LightBlue,
    WPTGO: SystemColorsEnum.Burgundy,
    WPTGPUKE: SystemColorsEnum.Bronze,
    UNKNOWN: SystemColorsEnum.DarkGrey,
    NEXAPOKER: SystemColorsEnum.Green,
    AKSPOKER: SystemColorsEnum.WarmYellow
  };
  const res = value === "UNKNOWN" || value === "NONE" ? void 0 : value;
  const label = res ? localizedPlatform[res] : void 0;
  return /* @__PURE__ */ React.createElement(
    CircleBoxWithColorMapping,
    {
      value: res,
      label: label ? formatMessage(label) : void 0,
      colorMapping
    }
  );
}
export {
  UserPlatform
};
//# sourceMappingURL=Platform.js.map
